// extracted by mini-css-extract-plugin
export var divider = "MGVOD";
export var logoDimensions = "QdAk_";
export var navMenuLayout = "hdfbL";